import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  getHandoverForGenericDynamicFormSendout,
  orderGenericDynamicFormSendout,
} from 'src/services/api/publicHandover';
import GenericSendOutView from 'src/pages/sendout/Generic/GenericMainView';
import { HandoverItemType } from 'src/types/handover';

function GenericSendoutView() {
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const token = params.get('token') || '';
  const { handoverId = '' } = useParams<{
    handoverId: string;
  }>();

  const getHandoverForSendoutView = (immediateParams: { itemType: HandoverItemType }) =>
    getHandoverForGenericDynamicFormSendout(token, handoverId);

  const orderForm = (body: { configId: string; handoverId: string }) =>
    orderGenericDynamicFormSendout(token, body);

  return (
    <>
      <GenericSendOutView
        getHandoverForSendoutView={getHandoverForSendoutView}
        orderForm={orderForm}
      />
    </>
  );
}

export default GenericSendoutView;
